/**
 * Settings sidebar navigation item.
 *
 * Uses the shared NavItem and NavGroupHeader components to ensure
 * consistent styling with the primary app navigation.
 */

import { useParams } from 'react-router-dom';

import { useOrg } from '@/contexts/OrgContext';
import { NavGroupHeader, NavItem } from '@/lib/base/nav';

import type { SettingsNavConfigItem } from './settings-nav-config';
import { DEFAULT_SECTION } from './settings-nav-config';

interface SettingsNavGroupHeaderProps {
  label: string;
}

/** Section group label (not a link). */
export function SettingsNavGroupHeader({ label }: SettingsNavGroupHeaderProps) {
  return <NavGroupHeader label={label} />;
}

interface SettingsNavItemProps {
  item: SettingsNavConfigItem;
}

/** Single settings section nav item with active indicator. */
export function SettingsNavItem({ item }: SettingsNavItemProps) {
  const { section } = useParams<{ section?: string }>();
  const { currentOrg } = useOrg();

  const isActive =
    section === item.id || (!section && item.id === DEFAULT_SECTION);

  if (!currentOrg?.id) {
    return null;
  }

  return (
    <NavItem
      label={item.label}
      href={`/${currentOrg.id}/settings/${item.id}`}
      icon={item.icon}
      current={isActive}
    />
  );
}
